import { CASE_METADATA_TAG, CASES_TAG } from '../constants';
import { api } from '../core';
import { PaginationProductTypeKeys } from './caseCreate';

export type CaseEditResponse = object;

export type CaseEditProps = { caseId: string } & Partial<{
  assignedTo?: string | null;
  caseReference: string;
  dueDate: string | null; // '2025-01-01';
  isUrgent: boolean;
  gRef: string | null;
  paginationProduct: PaginationProductTypeKeys;
  allegationDocumentIds: string[];
  // Optional instructing company (MLS org only). Send `null` to clear
  // a previously-selected value; omit to leave unchanged.
  instructingCompanyId: string | null;
}>;

const caseEditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseEdit: builder.query<CaseEditResponse, CaseEditProps>({
      query: (props: CaseEditProps) => {
        // Only include defined properties in the body
        const body: Record<string, unknown> = {};
        Object.entries(props).forEach(([key, value]) => {
          if (value !== undefined) {
            body[key] = value;
          }
        });

        return {
          url: 'case/edit',
          method: 'POST',
          body: body,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASES_TAG, CASE_METADATA_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseEdit in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseEditQuery } = caseEditApi;
